import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'nx-ng-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input()
  id = '';

  @Input()
  name = '';

  @Input()
  labelKey = '';

  @Input()
  htmlLabel?: string;

  @Input()
  isRequired = false;

  @Input()
  hasError = false;

  @Input()
  errorText = '';

  private localValue = false;
  private touched = false;

  get hasDictionaryLabel(): boolean {
    return typeof this.labelKey !== 'undefined' && this.labelKey.length > 0;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  set value(value: any) {
    this.localValue = value;
    this.onChange(value);
    this.onTouch();
  }

  get value(): any {
    return this.localValue;
  }

  onChange = (event: any) => {};
  onTouch = () => {};

  writeValue(value: any) {
    this.localValue = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  get errorId() {
    return `${this.id}-error`;
  }

  markAsTouched() {
    if (!this.touched) {
      this.touched = true;
      this.onTouch();
    }
  }
}
